import { IoChevronBack, IoChevronDown, IoChevronForward, IoTextOutline } from 'react-icons/io5';
import './ReadingToolbar.css';

const label = (ch) => `${ch.book} ${ch.chapter}`;

/** Sticky bar at the top of the reader: ‹ John 3 ▾ › and the Aa settings. */
const ReadingToolbar = ({
  currentChapter,
  prevChapter,
  nextChapter,
  onPrev,
  onNext,
  onOpenPicker,
  onOpenSettings
}) => (
  <div className="reading-toolbar">
    <button
      type="button"
      className="toolbar-icon"
      onClick={onPrev}
      disabled={!prevChapter}
      aria-label={prevChapter ? `Previous chapter, ${label(prevChapter)}` : 'Previous chapter'}
    >
      <IoChevronBack size={22} aria-hidden="true" />
    </button>

    <button
      type="button"
      className="toolbar-title"
      onClick={onOpenPicker}
      aria-haspopup="dialog"
      aria-label={`${label(currentChapter)}, choose a chapter`}
    >
      <span>{label(currentChapter)}</span>
      <IoChevronDown size={16} aria-hidden="true" />
    </button>

    <button
      type="button"
      className="toolbar-icon"
      onClick={onNext}
      disabled={!nextChapter}
      aria-label={nextChapter ? `Next chapter, ${label(nextChapter)}` : 'Next chapter'}
    >
      <IoChevronForward size={22} aria-hidden="true" />
    </button>

    <span className="toolbar-divider" aria-hidden="true" />

    <button
      type="button"
      className="toolbar-icon"
      onClick={onOpenSettings}
      aria-haspopup="dialog"
      aria-label="Text settings"
    >
      <IoTextOutline size={20} aria-hidden="true" />
    </button>
  </div>
);

export default ReadingToolbar;
